import React, { Component } from "react";
import ScatterPlot from "../charts/ScatterPlot";
import PageInfoDrawer from "../components/PageInfoDrawer";
import { withWindowDimensionsDOM } from "../components/withWindowDimensions";
import PageDataset from "./PageDataset";
import NodePopover from "./NodePopover";

const ActiveNodeContext = React.createContext();

class PageStatistics extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedPage: null,
      activeNode: null
    };

    this.handleDrawerClose = this.handleDrawerClose.bind(this);
    this.handleDotSelected = this.handleDotSelected.bind(this);
    this.handleDotHover = this.handleDotHover.bind(this);
    this.handlePageValueMatrixScopeChange = this.handlePageValueMatrixScopeChange.bind(
      this
    );
  }

  //getX(d) { return d.value + 1; }
  getX(d) {
    return d.valuePerVisit;
  }
  getY(d) {
    return d.visits;
  }
  getRadius(d) {
    return d.valuePerVisit;
  }
  getKey(d) {
    return d.key;
  }
  getName(d) {
    return d.pagename;
  }

  // TODO: refactor in node entity or helper func since we share it with popover
  getCategoryName(d) {
    const siteRoot = "root page";
    //TODO: this is a test. it only returns the first level for the category
    if (d.path === "/") {
      return siteRoot;
    }

    let parts = d.path.split("/");
    parts.shift();
    if (parts.length === 1) {
      return siteRoot;
    }

    //console.log(parts);
    return parts[0];
  }

  handleDotSelected(data) {
    this.setState({ pageMetrics: data });
  }

  handleDotHover(node) {
    this.setState({ activeNode: node });
  }

  handleDrawerClose() {
    this.setState({ pageMetrics: null });
  }

  handlePageValueMatrixScopeChange(scope) {}

  render() {
    const { isLoading, windowWidth, windowHeight, filters } = this.props;
    if (isLoading) return null;

    const { activeNode, pageMetrics } = this.state;

    let globalHeaderHeight = 0;
    const globalHeader = document.getElementsByClassName("sc-globalHeader");
    if (globalHeader && globalHeader.length > 0) {
      globalHeaderHeight = globalHeader[0].getBoundingClientRect().height;
    }

    //todo: switch to matrix service
    PageDataset.init(this.props.data.pageviews.data);
    let pv = PageDataset.getData();

    let isOpen = !(pageMetrics === null || pageMetrics === undefined);

    return (
      <div id="page-matrix">
        <ActiveNodeContext.Provider value={activeNode}>
          <ScatterPlot
            id="pageValueMatrix"
            data={pv}
            height={windowHeight - 140 - globalHeaderHeight}
            width={windowWidth - 85}
            getX={this.getX}
            getY={this.getY}
            getRadius={this.getRadius}
            getKey={this.getKey}
            getName={this.getName}
            getCategoryName={this.getCategoryName}
            xLabel="Value"
            yLabel="Visits"
            filters={filters}
            pageMetrics={pageMetrics}
            onDotHover={this.handleDotHover}
            onDotSelected={this.handleDotSelected}
            onScopeChanged={this.handlePageValueMatrixScopeChange}
          />
          <PageInfoDrawer
            isOpen={isOpen}
            pageMetrics={pageMetrics}
            closeDrawer={this.handleDrawerClose}
          />
          <ActiveNodeContext.Consumer>
            { node => <NodePopover node={node} />}
          </ActiveNodeContext.Consumer>
        </ActiveNodeContext.Provider>
      </div>
    );
  }
}

export default withWindowDimensionsDOM(PageStatistics);



// WEBPACK FOOTER //
// ./src/components/PageStatistics.js